import { Box, MenuItem, Typography } from '@mui/material'
import CustomDropdown from '../CustomDropdown'
import { useSelector } from 'react-redux'
import { createSelector } from '@reduxjs/toolkit'
import { RootState } from '../../store'
import { OrganizationLogo } from '../Svgs'

interface OrganizationSettingsProps {}

const selectedOrganizationSelector = createSelector(
  [(state: RootState) => state.organization],
  (organization) => organization.selectedOrganization,
)

const OrganizationSettingsComponent: React.FC<
  OrganizationSettingsProps
> = ({}) => {
  const selectedOrganization = useSelector(selectedOrganizationSelector)

  return (
    <Box
      sx={{
        display: 'flex',
        background: '#04002E',
        borderRadius: '0.4rem',
        boxShadow: '0px 2px 10px 0px #2F2F2F1A',
      }}
    >
      <CustomDropdown
        color='#fff'
        headerComponent={
          <Box
            display='flex'
            alignItems='center'
            gap='1rem'
            width='90%'
            py='0.25rem'
          >
            <OrganizationLogo />
            <Box display='flex' flexDirection='column' alignItems='flex-start'>
              <Typography
                sx={{
                  color: '#fff',
                  fontSize: '0.76rem',
                  lineHeight: 'normal',
                  fontWeight: 500,
                  textTransform: 'none',
                }}
              >
                {selectedOrganization?.name}
              </Typography>
              <Typography
                sx={{
                  color: '#fff',
                  fontSize: '0.7rem',
                  lineHeight: 'normal',
                  fontWeight: 500,
                  textTransform: 'none',
                }}
              >
                Engineering Connect
              </Typography>
            </Box>
          </Box>
        }
      >
        <MenuItem>
          <Typography
            sx={{
              fontSize: '0.7rem',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 'normal',
              p: '0.5rem',
            }}
          >
            Switch Workspaces
          </Typography>
        </MenuItem>
        <MenuItem>
          <Typography
            sx={{
              fontSize: '0.7rem',
              fontStyle: 'normal',
              fontWeight: 500,
              lineHeight: 'normal',
              p: '0.5rem',
            }}
          >
            Admin Workspace Settings
          </Typography>
        </MenuItem>
      </CustomDropdown>
    </Box>
  )
}

export default OrganizationSettingsComponent
